import styled from 'styled-components'

export const gradients = {
  info: 'linear-gradient(135deg, #402563, #114ee0)',
  sources: 'linear-gradient(135deg, #402563, #2042ba)',
  stats: 'linear-gradient(135deg, #402563, #2448cc)',
  settings: 'linear-gradient(135deg, #402563, #114ee0)',
  train: 'linear-gradient(135deg, #402563, #2042ba)',
} as const

export const ValueBox = styled.div`
  background: #1a1a1a;
  border-radius: 8px;
  padding: 1.25rem;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }

  .label {
    color: rgba(255, 255, 255, 0.7);
    font-size: 0.85rem;
    margin-bottom: 0.5rem;
  }

  .value {
    color: #ffffff;
    font-family: monospace;
    font-size: 0.9rem;
    word-break: break-all;
  }
`

export const StatCard = styled.div`
  background: #1a1a1a;
  border-radius: 8px;
  padding: 1.25rem;
  text-align: center;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .stat-number {
    color: #4dabf7;
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 0.5rem;
  }

  .text-muted {
    color: rgba(255, 255, 255, 0.7) !important;
    font-size: 0.9rem;
    font-weight: 500;
  }
`
